import { Link } from 'react-router-dom';

export default function SEOPreview() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-1/2">
            <div className="rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20fashion%20shopper%20desk%20with%20a%20laptop%20displaying%20a%20clean%20colorful%20spreadsheet%20interface%2C%20surrounded%20by%20neatly%20folded%20garments%20in%20warm%20beige%20and%20terracotta%20tones%2C%20a%20small%20succulent%20plant%2C%20soft%20natural%20daylight%20from%20window%2C%20minimal%20cream%20workspace%2C%20editorial%20productivity%20photography&width=800&height=600&seq=seo-preview-v2-001&orientation=landscape"
                alt="LitBuy Spreadsheet guide preview"
                className="w-full h-auto rounded-3xl"
              />
            </div>
          </div>

          <div className="lg:w-1/2">
            <span className="inline-block text-xs font-label font-semibold bg-accent-100 text-accent-800 px-3 py-1.5 rounded-full mb-4">
              Featured Guide
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              What Is a LitBuy Spreadsheet?
              <br />
              <span className="text-foreground-500">Complete Beginner Guide</span>
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              Whether you&rsquo;re a complete beginner or looking to refine your workflow, 
              our comprehensive guide walks you through everything you need to know about 
              litbuy spreadsheet. Learn about organization, automation, tracking, and best practices 
              that will transform the way you manage purchases.
            </p>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              From setting up your first spreadsheet to mastering advanced features, this guide 
              covers it all with step-by-step instructions, practical examples, and expert tips.
            </p>
            <div className="mt-7">
              <Link
                to="/what-is-litbuy-spreadsheet"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-900 rounded-full font-label font-semibold text-sm hover:bg-background-200 transition-all whitespace-nowrap cursor-pointer"
              >
                Read Full Guide
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}